import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import ServiceProvider from './ServiceProvider';
import { ActionHistory } from 'material-ui/svg-icons';
import ServiceProvidersHistoryDialog from 'components/Regions/Port/ServiceProviders/ServiceProvidersHistoryDialog';
import { IconButton } from 'material-ui';

const ServiceProviders = ({
    serviceProviders,
    rejectServiceProvider,
    approveServiceProvider,
}) => {
    const [openHistoryDialog, setOpenHistoryDialog] = useState(false);

    const toggleHistoryDialog = () => {
        setOpenHistoryDialog(!openHistoryDialog);
    };

    return (
        <Fragment>
            <div className='main__title row' style={{ margin: 0, display: 'flex', flexDirection: 'row-reverse' }} >
                <div className='col-xs-1'>
                    <IconButton onClick={toggleHistoryDialog}>
                        <ActionHistory color='#B3B3B3' />
                    </IconButton>
                </div>
            </div>

            <div className='service-providers'>
                <div className='table' style={{ margin: '0 0 70px 0' }}>
                    <div className='table-header'>
                        <div className='table-row'>
                            <div className='table-col'>
                                Activity
                            </div>
                            <div className='table-col'>
                                Company Name
                            </div>
                            <div className='table-col'>
                                Contact Details
                            </div>
                        </div>
                    </div>
                    <div className='table-body'>
                        {serviceProviders.map((serviceProvider, index) => (
                            <ServiceProvider
                                key={`service-provider-${index}`}
                                serviceProvider={serviceProvider}
                                rejectServiceProvider={rejectServiceProvider}
                                approveServiceProvider={approveServiceProvider}
                            />
                        ))}
                    </div>
                </div>
                <ServiceProvidersHistoryDialog
                    open={openHistoryDialog}
                    toggle={toggleHistoryDialog}
                />
            </div>
        </Fragment>
    );
};

ServiceProviders.propTypes = {
    serviceProviders: PropTypes.array,
    rejectServiceProvider: PropTypes.func,
    approveServiceProvider: PropTypes.func,
};

ServiceProviders.defaultProps = {
    serviceProviders: [],
    rejectServiceProvider: () => {},
    approveServiceProvider: () => {},
};

export default ServiceProviders;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersApproval/Component.jsx